export interface TableColumn {
  displayName: string;
  field: string;
  sortable: boolean;
  dataType?: TableDataType;
  dateFormat?: string;
  renderContents?: (value: any, row: any) => React.ReactNode;
  maxWidth?: number;
  minWidth?: number;
}

export enum TableDataType {
  LINK = "link",
  DATE = "date",
}
